import React, { useMemo, useCallback, useEffect } from "react";
import moment from "moment";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import { BACKEND_URL } from "../../constans";
import AddStopModal from "../Modals/AddStopModal";
import { axiosConfig } from "../../utils/axiosConfig";
import { getCookie } from "../../App";

import IconAdd from "../../assents/img/add.svg";
import IconRightArrow from "../../assents/img/rigthArrow.svg";
const BookWrapper = styled(Box)(({ theme, visible }) => ({
  position: "sticky",
  bottom: "-5px",
  transition: "all 1s",
  transform: visible ? "translateY(0px)" : "translateY(100px)",
  // transform: visible ? 'scale(1)' : 'scale(0)',
  opacity: visible ? 1 : 0,
  display: "flex",
  justifyContent: "space-between",
  padding: "20px",
  backgroundColor: "#ffffff",
  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

const AddStopButton = styled(Button)(({ theme }) => ({
  width: "130px",
  height: "64px",
  whiteSpace: "nowrap",
  padding: "22.5px",
  background: "#2bb656",
  borderRadius: "8px",
  border: "none",
  boxSizing: "border-box",
  textTransform: "none",
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#ffffff",
  cursor: "pointer",
  "&:hover": {
    background: "#2bb656",
  },
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

const Add = styled("img")(() => ({
  marginRight: "4px",
}));

const BookButton = styled(Button)(({ theme, padding }) => ({
  display: "flex",
  alignItems: "center",
  padding: `22.5px ${padding}`,
  background: "#1a1a1a",
  borderRadius: "8px",
  border: "none",
  boxSizing: "border-box",
  textTransform: "none",
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#ffffff",
  cursor: "pointer",
  "&:hover": {
    background: "#1a1a1a",
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: "auto",
    marginRight: "auto",
    padding: "22.5px 69.5px",
  },
}));

const RightArrow = styled("img")(() => ({
  marginLeft: "10px",
}));

const ButtonTotalText = styled("span")(({ theme }) => ({
  display: "block",
  marginLeft: "5px",
  fontWeight: 400,
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));
const TotalBlockButtons = ({
  mobileButtonsVisible,
  setDateNotEmpty,
  setTimeNotEmpty,
  setDropOffNotEmpty,
  setLocationNotEmpty,
  totalMinutes,
  dropOffLocation,
  setClickAdd,
  addedStops,
  defaultStops,
  total,
  tourDefaultPrice,
  slug,
  date,
  time,
  addStation,
  tourId,
  pickUpLocation,
  checkboxIsCheked,
  open,
  handleOpenModal,
  handleCloseModal,
  addedStopsId,
  setTotal,
  setDate,
}) => {
  const paddingBook = document.body.offsetWidth < 370 ? "5px" : "26px";
  const totalPrice = useMemo(() => {
    return (
      addedStops.reduce(
        (acc, el) =>
          acc +
          (Number(Number(el.price_adult).toFixed(0)) * total.adults +
            Number(Number(el.price_child).toFixed(0)) * total.children +
            Number(Number(el.price_infant).toFixed(0)) * total.infants +
            el.duration * el.price_minute),
        0
      ) + Number(Number(tourDefaultPrice).toFixed(0))
    );
  }, [addedStops, total, tourDefaultPrice]);

  const sendCookies = useCallback(
    async (
      date,
      time,
      adults_people,
      child_people,
      infant_people,
      language,
      total_cost,
      places_id,
      is_private,
      tour_route_id,
      pick_up,
      full_duration,
      drop_off,
      is_pick_and_drop
    ) => {
      try {
        const response = await axiosConfig({
          method: "post",
          url: `tour-api/send-data-from-cookies/`,
          data: {
            date,
            time,
            adults_people,
            child_people,
            infant_people,
            language,
            total_cost,
            places_id,
            is_private,
            tour_route_id,
            pick_up,
            full_duration,
            drop_off,
            is_pick_and_drop,
          },
          headers: {
            "X-CSRFToken": getCookie("csrftoken"),
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    [
      date,
      dropOffLocation,
      time,
      total,
      totalPrice,
      addedStops,
      slug,
      tourId,
      pickUpLocation,
      checkboxIsCheked,
      totalMinutes,
    ]
  );

  const handleSubmit = useCallback(async () => {
    if (
      pickUpLocation.trim().length === 0 ||
      pickUpLocation.trim().length < 15
    ) {
      if (!checkboxIsCheked) {
        if (
          dropOffLocation.trim().length === 0 ||
          dropOffLocation.trim().length < 15
        ) {
          setDropOffNotEmpty(true);
        }
      }
      if (!date) {
        setDateNotEmpty(true);
      }

      if (!time) {
        setTimeNotEmpty(true);
      }
      setLocationNotEmpty(true);
      return;
    }
    if (!checkboxIsCheked) {
      if (
        dropOffLocation.trim().length === 0 ||
        dropOffLocation.trim().length < 15
      ) {
        if (!date) {
          setDateNotEmpty(true);
        }

        if (!time) {
          setTimeNotEmpty(true);
        }
        setDropOffNotEmpty(true);
        return;
      }
    }

    if (!date) {
      if (!time) {
        setTimeNotEmpty(true);
      }
      setDateNotEmpty(true);
      return;
    }

    if (!time) {
      setTimeNotEmpty(true);
      return;
    }

    try {
      const response = await sendCookies(
        moment(date).format("MMMM DD, YYYY"),
        time.length > 0 ? time : "10:00",
        total.adults,
        total.children,
        total.infants,
        "English",
        totalPrice,
        addedStops.map((el) => el.id).join(","),
        "true",
        tourId,
        pickUpLocation,
        totalMinutes,
        checkboxIsCheked ? pickUpLocation : dropOffLocation,
        checkboxIsCheked ? "true" : "false"
      );

      document.cookie = `date=${moment(date).format("MMMM DD, YYYY")}; path=/`;
      document.cookie = `time=${time.length > 0 ? time : "10:00"}; path=/`;
      document.cookie = `adult_people=${total.adults}; path=/`;
      document.cookie = `child_people=${total.children}; path=/`;
      document.cookie = `infant_people=${total.infants}; path=/`;
      document.cookie = "language=English; path=/";
      document.cookie = `total=${totalPrice}; path=/`;
      document.cookie = `places_id=${addedStops
        .map((el) => el.id)
        .join(",")}; path=/`;
      document.cookie = "is_private=true; path=/";
      document.cookie = `tour_route_id=${tourId}; path=/`;
      document.cookie = `pick_up=${pickUpLocation}; path=/`;
      document.cookie = `full_duration=${totalMinutes}; path=/`;
      document.cookie = `drop_off=${
        checkboxIsCheked ? pickUpLocation : dropOffLocation
      }; path=/`;
      document.cookie = `is_pick_and_drop=${checkboxIsCheked}; path=/`;
      window.location.href = `${BACKEND_URL}booking/info/${slug}/`;
    } catch (error) {
      console.log(error);
    }
  }, [
    dropOffLocation,
    date,
    time,
    total,
    totalPrice,
    addedStops,
    slug,
    tourId,
    pickUpLocation,
    checkboxIsCheked,
    totalMinutes,
    sendCookies,
  ]);

  const { childrenCookie, adultsCookie, infantsCookie, dataCookie } =
    useMemo(() => {
      return {
        childrenCookie: document.cookie.includes("children_people_from_django")
          ? +document.cookie
              .match(/children_people_from_django=\d+/)[0]
              .slice(-1)
          : 0,
        infantsCookie: document.cookie.includes("infants_people_from_django")
          ? +document.cookie
              .match(/infants_people_from_django=\d+/)[0]
              .slice(-1)
          : 0,
        adultsCookie: document.cookie.includes("adults_people_from_django")
          ? +document.cookie.match(/adults_people_from_django=\d+/)[0].slice(-1)
          : 0,
        dataCookie: document.cookie.match(/data_from_django=.+;/)
          ? document.cookie.match(/data_from_django=.+;/)[0].slice(17, 32)
          : null,
      };
    }, [document.cookie]);

  useEffect(() => {
    if (childrenCookie > 0 || infantsCookie > 0 || adultsCookie > 0) {
      setTotal({
        ...total,
        children: childrenCookie ? childrenCookie : 0,
        infants: infantsCookie ? infantsCookie : 0,
        adults: adultsCookie ? adultsCookie : 1,
      });
    }

    if (dataCookie) {
      setDate(moment(dataCookie).format("MMM DD, YYYY"));
    }
  }, []);

  return (
    <>
      <BookWrapper visible={mobileButtonsVisible ? "true" : ""}>
        <AddStopButton onClick={handleOpenModal}>
          <Add src={IconAdd} />
          Add stop
        </AddStopButton>
        <BookButton padding={paddingBook} onClick={handleSubmit}>
          Book now <ButtonTotalText>(€{Math.ceil(totalPrice)})</ButtonTotalText>
          <RightArrow src={IconRightArrow} />
        </BookButton>
      </BookWrapper>
      <AddStopModal
        stops={defaultStops}
        addedStopsId={addedStopsId}
        total={total}
        tourDefaultPrice={tourDefaultPrice}
        setClickAdd={setClickAdd}
        addStation={addStation}
        open={open}
        handleClose={handleCloseModal}
      />
    </>
  );
};

export default TotalBlockButtons;
